export const GOOGLE_API_KEY = 'AIzaSyDUOkjPoIuDvIYhiLbtwKoFu1o8QMFlhF4';